import configuration from '../../constants/Configuration';
import FineUploaderS3 from 'fine-uploader-wrappers/s3';
import appParameters from './AppParameters';
import saveManager from './SaveManager';
import audioUtils from './AudioUtils';

const thumbnailDataUploader = {
    uploader: undefined,

    init() {
        var accessKey;
        var bucket;
        var acceptedString = 'image/png';
        var arg = {};
        var prefix;

        arg.options = {};
        if (configuration.IS_PROD() == true) {
            accessKey = 'AKIAJYMW5PW6FZLDMV2Q';
            bucket = 'creaza-thumbnails';
            prefix = 'https://s3.amazonaws.com/';
        } else {
            accessKey = 'AKIAJW24ZO65AI7KR7BA';
            bucket = 'creaza-stage-thumbnails';
            prefix = 'https://s3-eu-west-1.amazonaws.com/';
        }

        arg.options.autoUpload = true;
        arg.options.request = {endpoint: prefix + bucket, accessKey: accessKey, clockDrift: audioUtils.serverTimeOffset};
        arg.options.signature = {endpoint: '/ICSXapi/file/SignS3Policy'};
        arg.options.validation = {acceptFiles: acceptedString};

        arg.options.objectProperties = {
            key: function(fileId) {
                return 'Cartoonist/' + appParameters.currentUserId + '/' + this.getName(fileId);
            }
        };

        this.uploader = new FineUploaderS3(arg);
        this.uploader.on('complete', this.onComplete.bind(this));
        this.uploader.on('error', this.onFail.bind(this));
    },
    onComplete(type, name, state) {
        saveManager.uploadThumbnailSuccess(type, name, state);
    },
    onFail() {
        saveManager.uploadThumbnailError();
    },
    uploadFile(blob, title) {
        var blobWrapper = {blob: blob, name: title};

        this.uploader.methods.addFiles([blobWrapper]);
    }
};

export default thumbnailDataUploader;



/** WEBPACK FOOTER **
 ** ./src/components/utils/ThumbnailDataUploader.js
 **/